import { MAX_PLAYERS } from './players';

export const PERSONALITIES = ['confident', 'nervous', 'scrappy', 'sleepy'] as const;
export const ACCESSORIES = ['none', 'headband', 'glasses', 'wraps', 'gloves', 'scarf'] as const;
export const MARKINGS = ['plain', 'stripe', 'chevron', 'spots'] as const;
export const SKINS = ['classic', 'circuit', 'pulse'] as const;
export type Personality = typeof PERSONALITIES[number];
export type CharacterStyle = {
  personality: Personality;
  accessory: typeof ACCESSORIES[number];
  marking: typeof MARKINGS[number];
  /** Missing on older saved looks; normalized to classic when preferences are loaded. */
  skin?: typeof SKINS[number];
};

export function defaultCharacterStyle(color = 0): CharacterStyle {
  const index = Math.abs(Math.floor(color)) % MAX_PLAYERS;
  return { personality: PERSONALITIES[index % 4]!, accessory: ACCESSORIES[index % 4]!, marking: MARKINGS[Math.floor(index / 2) % 4]!, skin: 'classic' };
}

/** Cosmetic preferences are bounded and never enter the simulation or its random stream. */
export function characterStyle(value: unknown, color = 0): CharacterStyle {
  const fallback = defaultCharacterStyle(color);
  const candidate = value && typeof value === 'object' ? value as Partial<CharacterStyle> : {};
  return {
    personality: PERSONALITIES.includes(candidate.personality!) ? candidate.personality! : fallback.personality,
    accessory: ACCESSORIES.includes(candidate.accessory!) ? candidate.accessory! : fallback.accessory,
    marking: MARKINGS.includes(candidate.marking!) ? candidate.marking! : fallback.marking,
    skin: SKINS.includes(candidate.skin!) ? candidate.skin! : 'classic',
  };
}

export function characterStyles(value?: unknown): CharacterStyle[] {
  return Array.from({ length: MAX_PLAYERS }, (_, color) => characterStyle(Array.isArray(value) ? value[color] : undefined, color));
}
